module.exports = __webpack_public_path__ + "img/nextcloud.d0e47e81.png";